:host {
  display: inline-block;
  vertical-align: middle;
}

:host(.ux-icon--primary) {
  color: var(--ux-color-primary);
}

:host(.ux-icon--black) {
  color: $color-black;
}

:host(.ux-icon--white) {
  color: var(--ux-color-white);
}

.ux-icon {
  &__inner {
    display: block;
    height: 1em;
    width: 1em;
  }

  &__slot {
    display: none;
  }

  &__svg {
    display: block;
    height: 100%;
    width: 100%;
    fill: currentColor;
  }
}
